import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import BlueprintXAIPage from './pages/BlueprintXAIPage';
import ServicesPage from './pages/ServicesPage';
import './App.css';

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<BlueprintXAIPage />} />
          <Route path="/services" element={<ServicesPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
